import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import HERO_IMAGES from '../heroImages';
import SEO from '../components/SEO/SEO';
import portfolio from '../data/portfolio.json';
import './PortfolioPage.css';

const categories = ['All', ...new Set(portfolio.map(p => p.category))];

export default function PortfolioPage() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? portfolio : portfolio.filter(p => p.category === active);

  return (
    <main className="portfolio-page">
      <SEO
        title="Portfolio — Products We've Built"
        description="Explore ExploitEye's portfolio of secure, scalable web platforms, mobile apps, and digital products delivered for ambitious entrepreneurs and enterprises across India."
        path="/portfolio"
        keywords="web development portfolio, app development case studies, digital agency projects India"
      />
      <section className="page-hero" style={{ backgroundImage: `url(${HERO_IMAGES.portfolio})` }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span className="section-label">Our Work</span>
          <h1>Products We've<br /><span className="gradient-text">Engineered</span></h1>
          <p>A selection of platforms, apps, and digital products built for ambitious entrepreneurs.</p>
        </div>
      </section>

      <section style={{ padding: '72px 0', background: '#fff' }}>
        <div className="container">
          <div className="portfolio-filters">
            {categories.map(c => (
              <button key={c} className={`filter-btn ${active === c ? 'filter-btn--active' : ''}`} onClick={() => setActive(c)}>{c}</button>
            ))}
          </div>
          <div className="portfolio-grid">
            {filtered.map(p => (
              <div key={p.id} className="portfolio-card">
                <div className="portfolio-card__img">
                  <img src={p.image} alt={p.title} loading="lazy" />
                  <span className="portfolio-card__cat">{p.category}</span>
                </div>
                <div className="portfolio-card__body">
                  <h3 className="portfolio-card__title">{p.title}</h3>
                  <p className="portfolio-card__desc">{p.description}</p>
                  <div className="portfolio-card__tags">
                    {p.tags.map((t, i) => <span key={i} className="portfolio-card__tag">{t}</span>)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-strip">
        <div className="container">
          <div className="cta-strip-inner">
            <div className="cta-strip-text">
              <h2>Have a Project in Mind?</h2>
              <p>Let's discuss your vision and build something extraordinary.</p>
            </div>
            <div className="cta-strip-actions">
              <Link to="/contact" className="btn-primary">Start a Project <ArrowRight size={16} /></Link>
              <Link to="/pricing" className="btn-ghost">View Pricing</Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}